const debounce = require('debounce');

class HeaderSearch {
    constructor() {
        const searchWrapper = document.querySelector(
            '.header-middle__search-wrapper'
        );
        if (searchWrapper) {
            this.init(searchWrapper);
        }
    }

    init(root) {
        this.root = root;
        this.searchForm = this.root.querySelector(
            '.header-middle__search-form'
        );
        if (!this.searchForm) {
            return;
        }

        this.searchInput = this.searchForm.querySelector('.form-input__input');
        this.hintsWrapper = this.searchForm.querySelector(
            '.header-middle__search-hints'
        );
        this.hintsProductsWrapper = this.searchForm.querySelector(
            '.header-middle__hints-products-wrapper'
        );
        this.hintsResponseWrapper = this.searchForm.querySelector(
            '.header-middle__hints-products-list'
        );
        this.categorySelectWrapper = this.searchForm.querySelector(
            '.header-middle__select-wrapper'
        );
        this.loader = this.hintsWrapper.querySelector('.loader');
        this.allResultsButton = this.hintsWrapper.querySelector(
            '.header-middle__hints-all-results'
        );
        this.headerMiddle = this.root.closest('.header-middle');
        this.searchTopMobile = document.querySelector(
            '.header-middle__search-top-mobile'
        );
        this.hideMobileSearchButton = this.searchTopMobile
            ? this.searchTopMobile.querySelector('.js-hide-mobile-search')
            : null;

        // Required nodes for this component to function safely.
        if (
            !this.searchInput ||
            !this.hintsWrapper ||
            !this.hintsProductsWrapper ||
            !this.hintsResponseWrapper ||
            !this.loader ||
            !this.headerMiddle
        ) {
            return;
        }

        this.debounceSearch = debounce(this.search.bind(this), 1000);

        this.initMethods();
    }

    initMethods() {
        this.handleMobileHintsPosition();
        this.handleHideMobileSearch();
        this.handleSearchInput();
        this.handleCategorySelect();
        this.handleAllResultsClick();
        this.clearSitePreviousValue();
    }

    handleMobileHintsPosition() {
        window.addEventListener('resize', () => {
            if (window.innerWidth > 991.98) {
                this.hintsWrapper.style.removeProperty('top');
                this.hintsWrapper.style.removeProperty('height');
                document.body.style.removeProperty('overflow');
            } else if (this.hintsWrapper.classList.contains('-mobile-active')) {
                const height = this.headerMiddle.getBoundingClientRect().bottom;
                this.hintsWrapper.style.top = `${height}px`;
                this.hintsWrapper.style.height = `calc(100% - ${height}px)`;
            }
        });
        window.addEventListener('scroll', () => {
            if (
                window.innerWidth <= 991.98 &&
                this.hintsWrapper.classList.contains('-mobile-active')
            ) {
                const height = this.headerMiddle.getBoundingClientRect().bottom;
                this.hintsWrapper.style.top = `${height}px`;
                this.hintsWrapper.style.height = `calc(100% - ${height}px)`;
            }
        });
    }

    handleHideMobileSearch() {
        if (this.hideMobileSearchButton) {
            this.hideMobileSearchButton.addEventListener('click', () => {
                this.root.classList.remove('-focused');
                this.hintsWrapper.classList.remove('-mobile-active');
                this.hintsWrapper.classList.add('d-none');
                if (this.searchTopMobile) {
                    this.searchTopMobile.classList.add('d-none');
                    this.searchTopMobile.classList.remove('d-flex');
                }
                if (this.categorySelectWrapper) {
                    this.categorySelectWrapper.classList.remove('d-none');
                }
                document.body.style.removeProperty('overflow');
            });
        }
    }

    handleSearchInput() {
        this.searchInput.addEventListener('focus', () => {
            this.root.classList.add('-focused');
            if (window.innerWidth < 991.98) {
                this.hintsWrapper.classList.add('-mobile-active');
                if (this.searchTopMobile) {
                    this.searchTopMobile.classList.remove('d-none');
                    this.searchTopMobile.classList.add('d-flex');
                }
                const height = this.headerMiddle.getBoundingClientRect().bottom;
                this.hintsWrapper.style.top = `${height}px`;
                this.hintsWrapper.style.height = `calc(100% - ${height}px)`;
                document.body.style.overflow = 'hidden';
            } else {
                this.hintsWrapper.classList.remove('-mobile-active');
                this.hintsWrapper.style.removeProperty('top');
                this.hintsWrapper.style.removeProperty('height');
            }
            if (
                this.searchInput.value.length > 0 &&
                this.hintsWrapper.innerHTML.length > 0
            ) {
                this.hintsWrapper.classList.remove('d-none');
            }

            if (window.innerWidth < 991.98) {
                if (this.categorySelectWrapper) {
                    this.categorySelectWrapper.classList.add('d-none');
                }
            }
        });
        this.searchInput.addEventListener('blur', () => {
            if (window.innerWidth > 991.98) {
                this.root.classList.remove('-focused');
                setTimeout(() => {
                    this.hintsWrapper.classList.add('d-none');
                }, 200);
                if (this.categorySelectWrapper) {
                    this.categorySelectWrapper.classList.remove('d-none');
                }
            }
        });

        this.searchInput.addEventListener('input', e => {
            if (e.target.value.length > 0) {
                this.debounceSearch();
            } else {
                this.hintsWrapper.classList.add('d-none');
            }
        });
    }

    handleCategorySelect() {
        if (!this.categorySelectWrapper) {
            return;
        }

        this.categorySelectWrapper.addEventListener('onSelectChange', () => {
            if (this.searchInput.value.length > 0) {
                this.debounceSearch();
            }
        });
    }

    handleAllResultsClick() {
        if (!this.allResultsButton) {
            return;
        }

        this.allResultsButton.addEventListener('click', () => {
            this.searchForm.submit();
        });
    }

    clearSitePreviousValue() {
        window.addEventListener('pageshow', () => {
            this.searchInput.value = '';
        });
    }

    async search() {
        const formData = new FormData(this.searchForm);
        formData.append('action', 'mda_header_search');
        formData.append('nonce', ajax.nonce);

        try {
            this.loader.classList.add('-active');
            const req = await fetch(ajax.url, {
                method: 'POST',
                body: formData,
            });

            const { data } = await req.json();
            const { html, products_length } = data;

            this.hintsWrapper.classList.remove('d-none');
            this.hintsProductsWrapper.classList.remove('d-none');
            this.hintsResponseWrapper.innerHTML = html;
            if (this.categorySelectWrapper) {
                const selectWrapper = this.categorySelectWrapper.querySelector(
                    '.form-select__wrapper'
                );
                if (selectWrapper) {
                    selectWrapper.classList.remove('expanded');
                }
            }

            if (this.allResultsButton && this.allResultsButton.parentElement) {
                if (products_length > 0) {
                    this.allResultsButton.parentElement.classList.remove(
                        'd-none'
                    );
                } else {
                    this.allResultsButton.parentElement.classList.add('d-none');
                }
            }
        } catch (error) {
            console.log(`Error: ${error}`);
        } finally {
            this.loader.classList.remove('-active');
        }
    }
}

new HeaderSearch();
